import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '../../../models/User';
import {CommonOptions} from '../../../interfaces/interfaces';
import {FechasService} from '../../../services/utils/fechas.service';
import {CropperComponent} from 'angular-cropperjs';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AuthService} from '../../../services/modules/auth.service';
import {EmployerService} from '../../../services/modules/employer.service';
import {CommonService} from '../../../services/modules/common.service';
import {SnackBarService} from '../../../services/utils/snackBar.service';
import {environment} from '../../../../../environments/environment';
import {DialogService} from '../../../services/utils/dialog.service';
import {PersonalService} from '../../../services/modules/personal.service';
import {HttpErrorResponse} from '@angular/common/http';
import {TerminationService} from '../../../services/modules/termination-service';
import {AuthGuardService} from '../../../services/guards/AuthGuardService';

export interface DialogData {
  docs: any;
  module: string;
  title: string;
  typeToShow: number;
  typeGestor: string;
  adminInfoId: string;
  typeOperator: string;
  ssId?: any;
}

@Component({
  selector: 'app-dialog-carge-masivo',
  templateUrl: './dialog-carge-masivo.component.html',
  styleUrls: ['./dialog-carge-masivo.component.scss']
})
export class DialogCargeMasivoComponent implements OnInit {
  @ViewChild('angularCropper') angularCropper: CropperComponent;

  s3Bucket: string;
  imgCropperResult: string;

  email = '';
  module = '';
  urlFormat = '';
  commentary = '';
  stateString = '';
  typeShowDialog = 0;
  massUploadTypeId = 0;
  commentaryDocReq = '';
  commentaryDateReq = '';
  commentaryTermination = '';
  commentaryTerminationGenerate = '';

  cropper = false;
  isProcessing = false;
  showEndAccess = false;
  showFormatLoad = false;
  showDocumentLoad = false;
  showEmployerSelect = false;
  showDateReqFormatLoad = false;
  showBtnSaveTermination = false;
  showTerminationFormatLoad = false;
  showBtnSaveTerminationGenerate = false;
  showTerminationSelectFinalState = false;
  showTerminationFormatLoadGenerate = false;
  showTerminationSelectFinalStateGenerate = false;

  stories: any[] = [];
  documentos: any[] = [];
  storiesFiles: any[] = [];
  storiesFilesDoc: any[] = [];
  storiesFilesDateReq: any[] = [];
  storiesFilesTermination: any[] = [];
  storiesFilesTerminationGenerate: any[] = [];

  DocsJSON: any = {};
  massUploadInfo: any = {};

  state;
  stateCurrent;
  userAuth: User;
  stateCurrentDocReq;
  stateCurrentDateReq;
  formFile: FormGroup;
  formDate!: FormGroup;
  stateCurrentTermination;
  stateCurrentCommentsDocReq;
  stateCurrentCommentsDateReq;

  files: File[] = [];
  typesUpdate = [];
  filesDateReq: File[] = [];
  DateReqToSelect = [];
  employerToSelect = [];
  filesFormatLoad: File[] = [];
  TypeOfWithdrawals = [];
  filesTermination: File[] = [];
  filesLoadDateReq: File[] = [];
  TerminationToSelect = [];
  filesLoadDocument: File[] = [];
  requirementToSelect = [];
  proveedor: CommonOptions[] = [];
  lastStages: CommonOptions[] = [];
  filesLoadTermination: File[] = [];
  typesUpdateTermination = [];
  filesTerminationGenerate: File[] = [];
  TerminationEmployerToSelect = [];
  TerminationEmployerToSelectGenerate = [];

  permissions: string[] = [];
  permissionsCompany: string[] = [];

  date = new Date();
  formData = new FormData();
  controlSearchDateReq = new FormControl();
  controlSearchEmployer = new FormControl();
  controlSearchTypUpdate = new FormControl();
  controlSearchTermination = new FormControl();
  controlSearchTypeOfWithdrawals = new FormControl();
  controlSearchRequirementSelect = new FormControl();
  controlSearchTerminationEmployer = new FormControl();
  SearchTerminationEmployerGenerate = new FormControl();
  today = new Date(new Date().setHours(0, 0, 0, 0));
  controlSearchTypUpdateTermination = new FormControl(null);
  minDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());

  private lastMassUploadId?: number;

  constructor(
    private dialogRef: MatDialogRef<DialogCargeMasivoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private authService: AuthService,
    private authServiceGuard: AuthGuardService,
    private fechasService: FechasService,
    private commonService: CommonService,
    private snackBService: SnackBarService,
    private dialogService: DialogService,
    private personalService: PersonalService,
    private employerService: EmployerService,
    private terminationService: TerminationService
  ) {

    this.userAuth = this.authService.getUser();
    this.permissions = this.userAuth.claims;
    this.email = this.userAuth?.Email !== null && this.userAuth?.Email !== undefined ? this.userAuth?.Email : '';
    this.formFile = this.fb.group({
      File: '',
      Date: ''
    });
    this.typeShowDialog = this.data.typeToShow;
    this.module = this.data.module;
    this.stateCurrent = this.data.docs;
    this.stateCurrentDocReq = this.data.docs;
    this.stateCurrentDateReq = this.data.docs;
    this.stateCurrentCommentsDocReq = this.data.docs;
    this.stateCurrentCommentsDateReq = this.data.docs;
    this.state = this.stateCurrent.State;
    this.getUrlFormat();

    this.commonService.getCommonOptions('PersonalContractStage').subscribe((options: CommonOptions[]) => {
      this.lastStages = options;
      if (this.state !== undefined) {
        const selected: CommonOptions | undefined = this.lastStages.find(x => x.Value === this.state);
        if (selected !== undefined) {
          this.stateString = selected.Description?.toLocaleUpperCase() || '';
        }
      }
    });
    if (this.data.docs.StateId !== null && this.data.docs.StateId !== '' && this.data.docs.StateId !== undefined) {
      this.formFile.get('Date').setValue(this.stateCurrent?.Date);
    }
    if (this.module === 'Personal') {
      this.consumeApis();
    } else if (this.module === 'Termination' || this.module === 'GenerateWithdrawals') {
      // Solo Personal y Termination/GenerateWithdrawals consumen estas APIs. Planillas tiene su propio flujo.
      this.consumeApisTermination();
    }

    this.formDate = this.fb.group({
      DateEndAccess: [null],
    });
  }

  getLoadDocumentsByType(){
    switch (this.typeShowDialog) {
      case 1:
        this.loadDocuments();
        break;
      case 2:
        this.loadDocumentsDocReq();
        break;
      case 3:
        this.loadDocumentsDateReq();
        break;
    }
  }

  getUrlFormat() {
    switch (this.module){
      case 'Personal':
        this.urlFormat = 'https://analityco-acceso.s3.amazonaws.com/assets/files/Form+Agregar+Personal.xlsx';
        switch (this.typeShowDialog){
          case 2:
            this.urlFormat = 'https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/documents/Form%2BActualizar%2BDoc%2BRequisitos.xlsx';
            break;
          case 3:
            this.urlFormat = 'https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/documents/FormActualizarfecRequisitEmpresas.xlsx';
            break;
        }
        break;
      case 'Employer':
        this.urlFormat = 'https://analityco-acceso.s3.amazonaws.com/assets/documents/FormatoAgregarEmpresas.xlsx';
        break;
      case 'Planillas':
        this.urlFormat = 'https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/documents/Form_2BActualizar_2BPlanilla_(2).xlsx';
        break;
      case 'Termination':
        this.urlFormat = 'https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/documents/Form%252BActualizar%252BEstado.xlsx';
        break;
      case 'GenerateWithdrawals':
        this.urlFormat = 'https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/documents/Form_Generar_Retiros_Mul_Emp_V3.xlsx';
        break;
    }
  }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    if (this.module !== 'Planillas') {
      this.getInfoAdmin();
    }
  }

  consumeApis(){
    this.personalService.getMassUploadType().subscribe((data: any) => {
      this.typesUpdate = data.filter((item: any) => item.Name !== 'CARGA MASIVA SEGURIDAD SOCIAL');
      this.controlSearchTypUpdate.setValue(this.typeShowDialog);
    });
    this.personalService.getMassUploadInfo(this.typeShowDialog).subscribe((data: any) => {
      this.massUploadInfo = data;
      this.getLoadDocumentsByType();
    });
    if (this.typeShowDialog === 3) {
      this.commonService.getRequirementsCertPersonal(true).subscribe((data: any) => {
        this.DateReqToSelect = data.filter(x => x.IsActive === true && x.ByEntry === false && x.BySurvey === false &&
          x.EnableInputEntry === false).sort((a, b) => (a.OrderNum !== null ?
          a.OrderNum : Infinity)  > (b.OrderNum !== null ? b.OrderNum : Infinity) ? 1 : -1);
      });
    } else {
      this.commonService.getRequirement().subscribe((data: any) => {
        this.requirementToSelect = data.filter(x => x.IsActive === true && (x.ByPersonal === true || x.ByEmployerPersonal === true) &&
          x.ByEntry === false && x.BySurvey === false && x.EnableInputEntry === false &&
          x.BySecuritySocial === false).sort((a, b) => (a.OrderNum !== null ? a.OrderNum : Infinity)  > (b.OrderNum !== null ?
          b.OrderNum : Infinity) ? 1 : -1);
      });
    }
    this.personalService.getEmployerSelect().subscribe((data: any) => {
      this.employerToSelect = data;
    });
  }

  changeTypeUpdate(type){
    this.typeShowDialog = type;
    this.getLoadDocumentsByType();
    this.consumeApis();
  }

  consumeApisTermination(): void {
    this.terminationService.getMassUpload().subscribe((data: any[]) => {
      this.typesUpdateTermination = (data || []).map(x => ({
        Id: Number(x.Id),
        Name: x.Name,
        Description: x.Description,
      }));

      if (this.module === 'Termination') {
        this.typesUpdateTermination = this.typesUpdateTermination.filter(x => x.Id === 4);
      } else if (this.module === 'GenerateWithdrawals') {
        this.typesUpdateTermination = this.typesUpdateTermination.filter(x => x.Id === 5);
      }

      const wanted = Number(this.typeShowDialog);
      const selected = this.typesUpdateTermination.find(x => x.Id === wanted);
      Promise.resolve().then(() => this.controlSearchTypUpdateTermination.setValue(wanted));

      if (selected?.Id != null) {
        this.loadDocumentsTermination(selected.Id);
      }

      if (this.module === 'GenerateWithdrawals') {
        this.showTerminationFormatLoadGenerate = true;
      }

      this.personalService.getEmployerSelect().subscribe((emp: any[]) => {
        this.TerminationEmployerToSelect = emp;
        this.TerminationEmployerToSelectGenerate = emp;
      });

      const companyInfoId = this.data?.adminInfoId;
      if (companyInfoId) {
        this.personalService.getTypeOfWithdrawals(companyInfoId).subscribe((tow: any[]) => {
          this.TypeOfWithdrawals = tow ?? [];
        });
      }

      this.terminationService.getTerminationStages().subscribe((st: any[]) => {
        this.TerminationToSelect = st;
      });
    });
  }

  changeTypeUpdateTermination(event){
  }

  changeRequirementSelect(requirement?) {
    if (!requirement) { return; }

    this.showEmployerSelect = requirement.ByEmployerPersonal === true;
    this.showFormatLoad = requirement.ByEmployerPersonal === true || requirement.ByPersonal === true;
  }

  changeEmployerSelect(requirement){
    this.showFormatLoad = true;
  }

  changeDateReqSelect(requirement?) {
    if (!requirement) { return; }

    this.showDateReqFormatLoad = requirement.ByEmployerPersonal === true || requirement.ByPersonal === true;
  }

  changeTerminationSelect(requirement){
    this.showTerminationFormatLoad = true;
    this.showBtnSaveTermination = true;
  }

  changeTerminationSelectGenerate(selection: any){
    this.showTerminationFormatLoadGenerate = true;
    this.showBtnSaveTerminationGenerate = true;
    this.showEndAccess = !!selection;
  }

  changeTerminationEmployer(requirement){
    this.showTerminationFormatLoad = true;
  }

  changeTerminationEmployerGenerate(requirement){
    this.showTerminationFormatLoadGenerate = true;
  }

  getInfoAdmin() {
    this.permissionsCompany = this.authServiceGuard.auth.getUser().Companies.find(x => x.Id === this.data.adminInfoId).Permissions;
  }

  getDateFormatR(date): string {
    let response = '';
    if (date !== null) {
      response = this.fechasService.getDateFormatR(date);
    }
    return response;
  }

  getDateFormatRMinutes(date): string {
    let response: string;
    response = this.fechasService.getDateFormatRMinutes(date);
    return response;
  }

  getDateFormatDateGestorDocuemntsUpdate(date): string {
    let response = '';
    if (date !== null && date !== undefined) {
      response = this.fechasService.formatDateYYYYMMDDdatePikerWhitMinutes(date);
    }
    return response;
  }

  openImgVideo(doc: any): void {
    const urlDoc = this.getDocumentPath(doc);
    if (!urlDoc) {
      return;
    }
    window.open(this.s3Bucket + urlDoc, '_blank');
  }

  isXLSX(doc: any): boolean {
    const fileName = (doc?.nameFile || '').toString();
    if (fileName) {
      return fileName.toUpperCase().endsWith('.XLSX');
    }
    const path = this.getDocumentPath(doc).toUpperCase();
    return path.endsWith('.XLSX');
  }

  getUrlFile(doc: any): string {
    return this.s3Bucket + this.getDocumentPath(doc);
  }

  private getDocumentPath(doc: any): string {
    const rawPath = doc?.urlDoc || doc?.Key || doc?.key || doc?.docPath || '';
    if (!rawPath) {
      return '';
    }
    return rawPath.includes('||') ? rawPath.split('||')[0] : rawPath;
  }

  openImgVideoUrl(url: any) {
    window.open(this.s3Bucket + url, '_blank');
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  // METODOS PARA CORTAR UNA IMAGEN Y GUARDARLA
  onSelect(event) {
    this.files = [];
    const selectedFiles: FileList = event.addedFiles;
    const maxSize = 5 * 1024 * 1024;

    for (const file of Array.from(selectedFiles)) {
      if (file.size > maxSize) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 3000);
        return;
      }
      this.files.push(file);
    }
  }

  onSelectFormatLoad(event): void {
    this.filesFormatLoad = [];
    const selectedFiles: FileList = event.addedFiles;
    const maxSize: number = 5 * 1024 * 1024;

    for (const file of Array.from(selectedFiles)) {
      if (file.size > maxSize) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', undefined, 3000);
        return;
      }
      this.filesFormatLoad.push(file);
    }

    this.showDocumentLoad = true;
  }

  onSelectLoadDocument(event): void {
    this.filesLoadDocument = [];
    const selectedFiles: FileList = event.addedFiles;
    const maxSize = 5 * 1024 * 1024;

    for (const file of Array.from(selectedFiles)) {
      if (file.size > maxSize) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 3000);
        return;
      }
      this.filesLoadDocument.push(file);
    }
  }

  onSelectDateReq(event): void {
    this.filesDateReq = [];
    const selectedFiles: FileList = event.addedFiles;
    const maxSize = 5 * 1024 * 1024;

    for (const file of Array.from(selectedFiles)) {
      if (file.size > maxSize) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 3000);
        return;
      }
      this.filesDateReq.push(file);
    }
  }

  onSelectTermination(event): void {
    this.filesTermination = [];
    const selectedFiles: FileList = event.addedFiles;
    const maxSize = 5 * 1024 * 1024; // 5MB en bytes

    for (const file of Array.from(selectedFiles)) {
      if (file.size > maxSize) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 3000);
        return;
      }
      this.filesTermination.push(file);
    }

    this.showTerminationSelectFinalState = true;
  }

  onSelectTerminationGenerate(event) {
    this.filesTerminationGenerate = [];
    const selectedFiles: FileList = event.addedFiles;
    for (let i = 0; i < selectedFiles.length; i++) {
      this.filesTerminationGenerate.push(selectedFiles[i]);
    }
    this.showTerminationSelectFinalStateGenerate = true;
  }

  submitInitDocument(){
    const formData = new FormData();
    formData.append('File', this.files[0]);
    this.isProcessing = true;

    if (this.module === 'Personal') {
      this.personalService.putExtractFromDocument(this.data.adminInfoId, formData).subscribe((data) => {
        this.isProcessing = false;
        this.loadDocuments();
        this.files = [];
        this.snackBService.openWarning('Archivo subido correctamente.', '', 3000);

      }, (error: HttpErrorResponse) => {
        if (error.status === 420) {
          this.isProcessing = false;
          this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
        }
      });
    }else if (this.module === 'Employer') {
      this.employerService.putExtractFromDocumentEmployer(this.data.adminInfoId, formData).subscribe((data) => {
        this.isProcessing = false;
        this.loadDocuments();
        this.files = [];
        this.snackBService.openWarning('Archivo subido correctamente.', '', 3000);
      }, (error: HttpErrorResponse) => {
        if (error.status === 420) {
          this.isProcessing = false;
          this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
        }
      });
    }else if (this.module === 'Planillas') {
      this.personalService.putExtractFromDocument(this.data.adminInfoId, formData).subscribe((data) => {
        this.isProcessing = false;
        this.loadDocuments();
        this.files = [];
        this.snackBService.openWarning('Archivo subido correctamente.', '', 3000);
        // Cerrar el diálogo y retornar los datos para que planillas actualice su vista
        this.dialogRef.close({success: true, data});
      }, (error: HttpErrorResponse) => {
        this.isProcessing = false;
        if (error.status === 420) {
          this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
        } else {
          this.dialogService.openDialogGeneric('Error al cargar el archivo', 'Por favor, intente nuevamente.', 'CANCELAR');
        }
      });
    }
  }

  submitInitDocreq(){
    const formData = new FormData();
    formData.append('File', this.filesFormatLoad[0]);

    const formDataDocument = new FormData();
    formDataDocument.append('File', this.filesLoadDocument[0]);
    this.isProcessing = true;

    const requirementId = this.controlSearchRequirementSelect.value.Id;
    const employerId = this.controlSearchEmployer.value;

    const body = {
      TypeId: this.controlSearchTypUpdate.value,
      AdminInfoId: this.data.adminInfoId,
      RequirementId: requirementId,
      EmployerInfoId: employerId,
      Comments: this.commentaryDocReq
    };
    this.personalService.postMassUploadInit(body).subscribe(() => {
      this.personalService.putMassUploadInfoFile(this.massUploadInfo.Id, formData).subscribe(() => {
        this.filesFormatLoad = [];
        this.personalService.putMassUploadPayloadFile(this.massUploadInfo.Id, formDataDocument).subscribe(() => {
          this.personalService.postProcess(this.massUploadInfo.Id).subscribe(() => {
            this.isProcessing = false;
            this.filesLoadDocument = [];
            this.controlSearchRequirementSelect.setValue('');
            this.controlSearchEmployer.setValue('');
            this.snackBService.openWarning('Archivo subido correctamente.', '', 3000);
            this.loadDocumentsDocReq();
            this.commentaryDocReq = '';
          }); } , (error: HttpErrorResponse) => {
          if (error.status === 420) {
            this.isProcessing = false;
            this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
          }
        });
      });
    });
  }

  submitInitFechreq(){
    const formData = new FormData();
    formData.append('File', this.filesDateReq[0]);

    const formDataDocument = new FormData();
    formDataDocument.append('File', this.filesLoadDateReq[0]);
    this.isProcessing = true;

    const requirementId = this.controlSearchDateReq.value.Id;

    const body = {
      TypeId: this.controlSearchTypUpdate.value,
      AdminInfoId: this.data.adminInfoId,
      RequirementId: requirementId,
      Comments: this.commentaryDateReq
    };

    this.personalService.postMassUploadInit(body).subscribe((dataInit: any) => {
      const massUploadId = dataInit?.Id;
      this.personalService.putMassUploadInfoFile(massUploadId, formData).subscribe(() => {
        this.filesDateReq = [];
        this.personalService.postProcess(massUploadId).subscribe(() => {
            this.isProcessing = false;
            this.filesLoadDateReq = [];
            this.controlSearchDateReq.setValue('');
            this.snackBService.openWarning('Archivo subido correctamente.', '', 3000);
            this.loadDocumentsDateReq();
            this.commentaryDateReq = '';
          }, (error: HttpErrorResponse) => {
          if (error.status === 420) {
            this.isProcessing = false;
            this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
          }
        });
      });
    });
  }

  submitInitTermination(){
    const formData = new FormData();
    formData.append('File', this.filesTermination[0]);

    const formDataDocument = new FormData();
    formDataDocument.append('File', this.filesTermination[0]);
    this.isProcessing = true;

    const employerId = this.controlSearchTerminationEmployer.value;
    const Id = this.controlSearchTermination.value.Id;

    const body = {
        TypeId: this.controlSearchTypUpdateTermination.value,
        AdminInfoId: this.data.adminInfoId,
        EmployerInfoId: employerId,
        Comments: this.commentaryTermination,
        NewStateId: Id
      };
    this.personalService.postMassUploadInit(body).subscribe((dataInit: any) => {
      const massUploadId = Number(dataInit?.Id);
      this.personalService.putMassUploadInfoFile(dataInit.Id, formData).subscribe(() => {
            this.filesTermination = [];
            this.personalService.postProcess(dataInit.Id).subscribe(() => {
            this.snackBService.openWarning('Archivo subido correctamente.', 'X', 3000);
            this.isProcessing = false;
            this.filesLoadTermination = [];
            this.controlSearchTermination.setValue('');
            this.controlSearchTerminationEmployer.setValue('');
            this.SearchTerminationEmployerGenerate.setValue('');
            this.loadDocumentsTermination(massUploadId);
            this.commentaryTermination = '';
            this.showBtnSaveTermination = false;
            });
        }, (error: HttpErrorResponse) => {
          if (error.status === 420) {
            this.isProcessing = false;
            this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
          }
        });
      });
  }

  OnsubmitTerminationGenerateWithdrawals(): void {
    this.isProcessing = true;

    const file = this.filesTerminationGenerate?.[0];
    const retirementTypeId = this.controlSearchTypeOfWithdrawals?.value?.Id ??
      this.controlSearchTypeOfWithdrawals?.value;
    const rawDate = this.formDate?.get('DateEndAccess')?.value ?? null;

    if (!file || !retirementTypeId || !rawDate) {
      this.isProcessing = false;
      return;
    }

    const terminationDate: string =
      typeof rawDate === 'string' ? rawDate : new Date(rawDate).toISOString().slice(0, 10);

    const companyInfoId = this.data.adminInfoId;
    const body = { terminationDate, retirementTypeId, companyInfoId };

    this.personalService.postMassUploadCreateTerminations(body).subscribe({
      next: (res: any) => {
        const massUploadId = Number(res?.Id);
        if (!massUploadId) {
          this.isProcessing = false;
          return;
        }

        const fd = new FormData();
        fd.append('file', file);

        this.personalService.putMassUploadInfoFile(massUploadId.toString(), fd).subscribe({
          next: () => {
            this.personalService.postProcess(massUploadId).subscribe({
              next: () => {
                this.snackBService.openWarning('Archivo subido y proceso iniciado.', 'X', 3000);
                this.isProcessing = false;
                this.filesTerminationGenerate = [];
                this.commentaryTerminationGenerate = '';
                this.controlSearchTypeOfWithdrawals.setValue('');
                this.formDate.reset();
                this.showBtnSaveTerminationGenerate = false;
                this.showEndAccess = false;
                this.loadDocumentsTermination(this.massUploadTypeId);
              },
              error: () => this.handleInitError()
            });
          },
          error: () => this.handleInitError()
        });
      },
      error: () => this.handleInitError()
    });
  }

  submitInitPlanillas(){
    const formData = new FormData();
    formData.append('File', this.files[0]);
    this.isProcessing = true;

    if (this.module === 'Planillas') {
      const ssId = this.data.ssId;
      const body = { Comments: this.commentary };

      this.employerService.putMassUploadSocialSecurity(ssId, formData).subscribe(() => {
        this.employerService.postMassUploadSocialSecurity(ssId, body).subscribe(() => {
          this.isProcessing = false;
          this.files = [];
          this.commentary = '';
          this.snackBService.openWarning('Archivo subido correctamente.', 'X', 3000);
          this.dialogRef.close({success: true});
        }, (error: HttpErrorResponse) => {
          this.isProcessing = false;
          if (error.status === 420) {
            this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
          } else {
            this.dialogService.openDialogGeneric('Error al iniciar el proceso', 'Por favor, intente nuevamente.', 'CANCELAR');
          }
        });
      }, (error: HttpErrorResponse) => {
        this.isProcessing = false;
        if (error.status === 420) {
          this.dialogService.openDialogGeneric('Lo sentimos, no se puede iniciar la actualizacion', 'se recomienda revisar el archivo cargado.', 'CANCELAR');
        } else {
          this.dialogService.openDialogGeneric('Error al cargar el archivo', 'Por favor, intente nuevamente.', 'CANCELAR');
        }
      });
    }
  }

  private handleInitError(): void {
    this.isProcessing = false;
    this.dialogService.openDialogGeneric(
      'Lo sentimos, no se puede iniciar el retiro',
      'se recomienda revisar el archivo cargado.',
      'CERRAR'
    );
  }

  removeFile() {
    this.files = [];
  }

  removeFileFormatLoad() {
    this.filesFormatLoad = [];
  }

  removeFileLoadDocument() {
    this.filesLoadDocument = [];
  }

  removeFileDateReq() {
    this.filesDateReq = [];
  }

  removeFileTermination() {
    this.filesTermination = [];
  }

  removeFileTerminationGenerate() {
    this.filesTerminationGenerate = [];
    this.showEndAccess = false;
  }

  loadDocuments(){
    if (this.module === 'Personal') {
      this.personalService.getExtractFromDocument(this.data.adminInfoId).subscribe((data: any) => {
        this.stateCurrent = data;
        this.stories.push(data);
        this.storiesFiles = data.Files;
      });
    }else if (this.module === 'Employer') {
      this.employerService.getExtractFromDocumentEmployer(this.data.adminInfoId).subscribe((data: any) => {
        this.stateCurrent = data;
        this.stories.push(data);
        this.storiesFiles = data.Files;
      });
    }
  }

  loadDocumentsDocReq() {
      this.personalService.getMassUploadProcessId(this.massUploadInfo.Id).subscribe((data: any) => {
        this.stateCurrentDocReq = data;
        this.storiesFilesDoc = data.map((story: any) => {
          if (story.InfoDocJson) {
            try {
              const infoDocJson = JSON.parse(story.InfoDocJson);
              if (infoDocJson['DOC-1']) {
                const docInfoArray = infoDocJson['DOC-1'].split('||');
                story.docPath = docInfoArray[0];
                const namePart = docInfoArray.find(part => part.startsWith('name='));
                if (namePart) {
                  story.docName = namePart.split('=')[1];
                }
              }
            } catch (error) {
            }
          }
          return story;
        });
      });
  }

  loadDocumentsDateReq(){
      this.personalService.getMassUploadProcessId(this.massUploadInfo.Id).subscribe((data: any) => {
        this.stateCurrentDateReq = data;
        this.storiesFilesDateReq = data.map((story: any) => {
          if (story.InfoDocJson) {
            try {
              const infoDocJson = JSON.parse(story.InfoDocJson);
              if (infoDocJson['DOC-1']) {
                const docInfoArray = infoDocJson['DOC-1'].split('||');
                story.docPath = docInfoArray[0];
                const namePart = docInfoArray.find(part => part.startsWith('name='));
                if (namePart) {
                  story.docName = namePart.split('=')[1];
                }
              }
            } catch (error) {}
          }
          return story;
        });
      });
  }

  loadDocumentsTermination(massUploadTypeId: number): void {
    this.massUploadTypeId = massUploadTypeId;

    this.personalService.getMassUploadInfoInt(massUploadTypeId).subscribe({
      next: (data: any) => {
        const massUploadId = data?.Id ? Number(data.Id) : null;
        if (!massUploadId) {
          this.storiesFilesTermination = [];
          this.storiesFilesTerminationGenerate = [];
          this.documentos = [];
          return;
        }
        this.personalService.getMassUploadProcessId(massUploadId).subscribe((processData: any) => {
          this.stateCurrentTermination = processData;
          this.storiesFilesTermination = processData?.Files || [];

          if (this.module === 'GenerateWithdrawals') {
            this.terminationService.getHistoryGenerateWithdrawals(massUploadId).subscribe((history: any[]) => {
              this.storiesFilesTerminationGenerate = history || [];
              this.documentos = this.storiesFilesTerminationGenerate;
            });
          } else {
            this.documentos = this.storiesFilesTermination;
          }
        });
      },
      error: () => {
        this.storiesFilesTermination = [];
        this.storiesFilesTerminationGenerate = [];
        this.documentos = [];
      }
    });
  }

  getInfoDocValue(infoDocJson: string): string {
    if (!infoDocJson) {
      return '';
    }

    try {
      const parsedInfoDoc = JSON.parse(infoDocJson);

      const firstKey = Object.keys(parsedInfoDoc)[0];

      if (!firstKey) {
        return '';
      }

      return parsedInfoDoc[firstKey] || '';
    } catch (error) {
      return '';
    }
  }

  getInfoDocFileName(infoDocJson: string): string {
    const infoDocValue = this.getInfoDocValue(infoDocJson);

    if (!infoDocValue) {
      return '';
    }

    const infoParts = infoDocValue.split('||');

    const namePart = infoParts.find((part: string) => part.startsWith('name='));

    if (namePart) {
      return namePart.replace('name=', '');
    }

    const filePath = infoParts[0];

    if (!filePath) {
      return '';
    }

    return filePath.split('/').pop() || '';
  }

  getInfoDocFileUrl(infoDocJson: string): string {
    const infoDocValue = this.getInfoDocValue(infoDocJson);

    if (!infoDocValue) {
      return '';
    }

    const infoParts = infoDocValue.split('||');

    const filePath = infoParts[0];

    if (!filePath) {
      return '';
    }

    return filePath;
  }

  openInfoDocFile(infoDocJson: string): void {
    const fileUrl = this.getInfoDocFileUrl(infoDocJson);

    if (!fileUrl) {
      return;
    }

    const fullUrl = fileUrl.startsWith('http') ? fileUrl : this.s3Bucket + fileUrl;
    const fileName = this.getInfoDocFileName(infoDocJson) || 'documento.xlsx';

    const link = document.createElement('a');
    link.href = fullUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }

  getMassUploadHistoryDate(date: string): string {
    if (!date) {
      return '';
    }

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    const months = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];

    const day = parsedDate.getDate();
    const month = months[parsedDate.getMonth()];
    const year = parsedDate.getFullYear().toString().slice(-2);
    const hours = parsedDate.getHours().toString().padStart(2, '0');
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');

    return `${day} ${month} ${year} ${hours}:${minutes}`;
  }

  openDialogInforme(doc: any): void {
    const terminationDocumentId = Number(doc?.TerminationDocumentId);

    if (!terminationDocumentId) {
      this.snackBService.openWarning('No se encontró el documento para consultar el informe.', 'X', 3000);
      return;
    }

    this.dialogService.openDialogGenerateWithdrawalsReportComponent(terminationDocumentId);
  }

  exitPermissionCompany(permiso: string): boolean {
    let exit: boolean;
    const permisionsUserInfo  = this.permissionsCompany.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }
}
